import { useFeatureIsOn } from '@growthbook/growthbook-react';

import Card from '@/components/Card';
import Page from '@/components/Page';
import Stack from '@/components/Stack';
import { Body, Heading } from '@/components/Typography';
import { FEATURE_TOGGLE } from '@/constants/featuretoggle';

// Vexo dashboard URL — leaving as the public marketing site for now since
// the tenant-specific dashboard URL (and how to authenticate to it) is one
// of the pre-rollout open questions for Vexo support.
const VEXO_DASHBOARD_URL = 'https://www.vexo.co/';

const Analytics = () => {
  const enabled = useFeatureIsOn(FEATURE_TOGGLE.VexoAnalytics);
  const isProduction = process.env.NODE_ENV === 'production';
  const sdkLoaded =
    typeof window !== 'undefined' &&
    !!(window as Window & { vexo?: unknown }).vexo;

  return (
    <Page title="Analytics">
      <Stack vertical gap="20px">
        <Card>
          <Stack vertical gap="12px">
            <Heading>Vexo Analytics</Heading>
            <Body>
              Session recordings, heatmaps, and custom events are captured
              automatically when the SDK is enabled.
            </Body>

            <Body>
              <strong>
                GrowthBook flag (`{FEATURE_TOGGLE.VexoAnalytics}`):
              </strong>{' '}
              {enabled ? 'on' : 'off'}
            </Body>
            <Body>
              <strong>Environment:</strong>{' '}
              {isProduction ? 'production' : 'non-production (SDK skipped)'}
            </Body>
            <Body>
              <strong>SDK loaded on this tab:</strong>{' '}
              {sdkLoaded ? 'yes' : 'no'}
            </Body>
          </Stack>
        </Card>

        <Card>
          <Stack vertical gap="8px">
            <Heading>Operator notes</Heading>
            <Body>
              <strong>Kill switch:</strong> flip the GrowthBook flag{' '}
              <code>{FEATURE_TOGGLE.VexoAnalytics}</code> to disable the SDK for
              new sessions. In-flight sessions keep recording until the browser
              reloads.
            </Body>
            <Body>
              <strong>Dashboard:</strong>{' '}
              <a
                href={VEXO_DASHBOARD_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                Open Vexo dashboard ↗
              </a>
            </Body>
          </Stack>
        </Card>
      </Stack>
    </Page>
  );
};

export default Analytics;
